import { useBetweenCities } from "./useBetweenCities";
import { usePorts } from "./usePorts";

export const useReceptionCenterSideEffect = ({ queryParams, isBetweenCities, isFromPorts }) => {
    const portsSideEffect = usePorts({
        queryParams,
        isFromPorts
    });


    
    const betweenCitiesSideEffect = useBetweenCities({
        queryParams,
        isBetweenCities
    });

    if (isFromPorts) {
        return portsSideEffect;
    }
    if (isBetweenCities) {
        return betweenCitiesSideEffect;
    }


    return {
        data: [],
        meta: {
            count: 0,
            total: 0,
            per_page: 0,
            current_page: 0,
            total_pages: 0,
        },
        cancelMutation: () => { },
        unassignMutation: () => { },
        downloadMadinaTafweejManifestMutation: () => { },
        loading: false,
        isPending: false,
    };
}